import React, { useContext, useState } from "react";
import { Context } from ".";
import trashIconImage from "../../../assets/panorama/trash.png";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import { ReactComponent as PinSvg } from "../../../assets/newProject/pin.svg";
import { ReactComponent as PositionSvg } from "../../../assets/newProject/position.svg";
import { ReactComponent as CloseSvg } from "../../../assets/auth/login-close.svg";

import hotspotPinImage from "../../../assets/panorama/hotspot.gif";
import hotspotPin2Image from "../../../assets/panorama/icons/hotspot-3.gif";
import hotspotPin3Image from "../../../assets/panorama/icons/hotspot-4.gif";
import imagePinImage from "../../../assets/panorama/icons/image.gif";
import leftTurnImage from "../../../assets/panorama/icons/left.gif";
import rightTurnImage from "../../../assets/panorama/icons/right.gif";
import forwardTurnImage from "../../../assets/panorama/icons/forward.gif";
import leftTurn2Image from "../../../assets/panorama/icons/left-2.gif";
import rightTurn2Image from "../../../assets/panorama/icons/right-2.gif";
import voiceMemoImage from "../../../assets/panorama/icons/voice.gif";
import { uuidv4 } from "../../../helpers/common.helper";

const HOTSPOT_TYPE = {
  WALK_WAY: 1,
  INFO: 2,
  VOICE_MEMO: 3,
  PICTURE: 4,
};

export const EditHotspot = () => {
  const prefix = "new-project-hotspot-pannellum-edit";
  const {
    images,
    editHotspot,
    selectedImageName,
    setEditHotspot,
    closeOverlay,
    setHotspots,
    setScenes,
    removeHotspot,
    switchToPlaceHotspot,
    addHotspot,
  } = useContext(Context);
  const { getLang, confirm } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const [type, setType] = useState(undefined);
  const [selectedIconIndex, setSelectedIconIndex] = useState(
    editHotspot?.iconIndex ?? null
  );

  const handleDeleteHotspot = () => {
    const { id } = editHotspot;

    removeHotspot(selectedImageName, id);
    closeOverlay();
  };

  const handleSelectIconClick = ({ index, icon }) => {
    // setCustomIcon(icon);
    setSelectedIconIndex(index);
  };

  const HotspotIconDiv = ({ index, icon, name, isCustom, onSelect }) => {
    const [file, setFile] = useState(undefined);

    const handleSelectHotspotIcon = (file) => {
      onSelect({
        index: isCustom ? -1 : index,
        icon: isCustom ? file : null,
      });
    };

    const handleFileChanged = (e) => {
      if (!e.target.files || e.target.files.length === 0) {
        return;
      }

      try {
        setFile(e.target.files[0]);
        handleSelectHotspotIcon(e.target.files[0]);
      } catch (error) {
        console.error(error);
      }
    };

    const classNames = [
      `${prefix}-content-arrows-item`,
      `${prefix}-content-arrows-item--${isCustom ? "custom" : index}`,
    ];

    if (selectedIconIndex === index) {
      classNames.push(`${prefix}-content-arrows-item--active`);
    }

    return (
      <div
        className={classNames.join(" ")}
        onClick={() => {
          if (isCustom) return;
          handleSelectHotspotIcon();
        }}
      >
        {!isCustom && (
          <img
            className={`${prefix}-content-arrows-item__icon`}
            alt="arrow"
            src={icon}
          />
        )}
        {isCustom && (
          <div className={`${prefix}-content-arrows-item-custom`}>
            {!file && <AddCustomSvg width={28} />}
            <input
              id="hotpsot-custom-icon"
              className="fileuploader-original"
              type="file"
              onChange={handleFileChanged}
            />
            <label
              className={`${prefix}-content-arrows-item-custom-label`}
              htmlFor="hotpsot-custom-icon"
            >
              {!file && "Custom"}
              {file && (
                <img
                  className={`${prefix}-content-arrows-item-custom--image`}
                  alt="custom-icon"
                  src={URL.createObjectURL(file)}
                  htmlFor="hotpsot-custom-icon"
                />
              )}
            </label>
          </div>
        )}
      </div>
    );
  };

  const _getRender = () => {
    if (type === "icon") {
      return (
        <>
          <div className={`${prefix}-content-header`}>
            <div
              className={`${prefix}-content-header__return`}
              onClick={() => {
                setType(undefined);
                setSelectedIconIndex(editHotspot.iconIndex);
              }}
            >
              Return
            </div>
            <div
              className={`${prefix}-content-header__confirm`}
              onClick={() => {
                const {
                  id,
                  text,
                  desc,
                  sceneName,
                  type: hotspotType,
                  iconIndex,
                  customIcon,
                  file,
                  pitch,
                  yaw,
                } = editHotspot;

                removeHotspot(selectedImageName, id);

                addHotspot(selectedImageName, {
                  id: uuidv4(),
                  text,
                  desc,
                  sceneName,
                  type: hotspotType,
                  icon: selectedIconIndex,
                  customIcon,
                  file,
                  pitch,
                  yaw,
                });

                closeOverlay();
              }}
            >
              Confirm
            </div>
          </div>
          <span className={`${prefix}-content__heading`}>
            Select a new icon
          </span>
          <div className={`${prefix}-content-arrows`}>
            <HotspotIconDiv
              index={1}
              icon={forwardTurnImage}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={2}
              icon={leftTurnImage}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={3}
              icon={leftTurn2Image}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={4}
              icon={rightTurnImage}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={5}
              icon={rightTurn2Image}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={6}
              icon={hotspotPinImage}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={7}
              icon={hotspotPin2Image}
              onSelect={handleSelectIconClick}
            />
            <HotspotIconDiv
              index={8}
              icon={hotspotPin3Image}
              onSelect={handleSelectIconClick}
            />
            {/* <HotspotIconDiv isCustom={true} onSelect={handleSelectIconClick} /> */}
          </div>
        </>
      );
    }

    const {
      id,
      text,
      desc,
      sceneName,
      type: hotspotType,
      iconIndex,
      customIcon,
      file,
    } = editHotspot;

    return (
      <>
        {hotspotType === HOTSPOT_TYPE.WALK_WAY && id !== "temp" && (
          <img
            className={`${prefix}-content__scene-image`}
            src={URL.createObjectURL(
              images.find((image) => image.name === sceneName ?? "")
            )}
            alt="panomara"
          />
        )}
        <div
          className={`${prefix}-content-option`}
          onClick={() => {
            setEditHotspot(undefined);
            switchToPlaceHotspot({
              ...editHotspot,
              icon: iconIndex,
              title: text,
            });
          }}
        >
          <PositionSvg width={20} style={{ padding: 2 }} />
          <span className={`${prefix}-content-option__text`}>
            {TranslationCommon("Change Position")}
          </span>
        </div>
        {hotspotType === HOTSPOT_TYPE.WALK_WAY && (
          <div
            className={`${prefix}-content-option`}
            onClick={() => {
              setType("icon");
            }}
          >
            <PinSvg height={24} />
            <span className={`${prefix}-content-option__text`}>
              {TranslationCommon("Change Icon")}
            </span>
          </div>
        )}
        <div
          className={`${prefix}-content-option ${prefix}-content-remove`}
          onClick={() => {
            let _type = "";

            switch (hotspotType) {
              case HOTSPOT_TYPE.INFO:
                _type = "info";
                break;
              case HOTSPOT_TYPE.PICTURE:
                _type = "picture";
                break;
              case HOTSPOT_TYPE.VOICE_MEMO:
                _type = "voice memo";
                break;
              case HOTSPOT_TYPE.WALK_WAY:
                _type = "change scene";
                break;
              default:
                break;
            }

            confirm(
              `Delete`,
              `Confirm removing this ${_type} ${text} hotspot?`,
              [
                { id: "cancel", label: "Cancel", variant: "secondary" },
                { id: "confirm", label: "Delete", variant: "primary" },
              ],
              (action) => {
                if (action.id === "cancel") {
                  return;
                }

                handleDeleteHotspot();
              }
            );
          }}
        >
          <img
            className={`${prefix}-content-option__icon`}
            alt="delete"
            src={trashIconImage}
            width={16}
          />
          <span className={`${prefix}-content-option__text`}>
            {TranslationCommon("Delete")}
          </span>
        </div>
      </>
    );
  };

  return (
    <div className={prefix}>
      <div className={`${prefix}-close`} onClick={closeOverlay}>
        <CloseSvg width={12} />
        Close
      </div>
      <div className={`${prefix}-content`}>{_getRender()}</div>
    </div>
  );
};
